import { render, staticRenderFns } from "./InfoBadge.vue?vue&type=template&id=77ce5622&"
import script from "./InfoBadge.vue?vue&type=script&lang=ts&"
export * from "./InfoBadge.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports